import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip
} from "reactstrap";

import MakeAPICall from "../../apiCalls/common";

import { sendNotificationsApiRoute, sendNotificationsPatientApiRoute } from "../../apiRoutes";

import { logOutUser } from "../../reduxStore/actions/auth";
import appRoutes from "../../routes/appRoutes";

import SearchPR from "../SearchPR";
import CustomModal from "../../components/modal";
import SendNotificationForm from "../SendNotificationForm";

import ICLogo from "../../assets/images/web-logo_n.png";
import ICNoImg from "../../assets/images/default-picture.png";

import Button from "../../components/button";

const TopNavBar = props => {
  const user = props.auth.user;
  const [apiCallParams, setApiCallParams] = useState(null);
  let [showNotificationModal, setShowNotificationModal] = useState(false);
  let [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");

  // we will store doctors list on this tooltip. Doctors who are connected to socket at the moment
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleNotificationModal = () => {
    setShowNotificationModal(!showNotificationModal);
  };

  const toggleLogoutModal = () => {
    setShowLogoutModal(!showLogoutModal);
  };

  const logOut = async () => {
    await props.logOutUser();
  };

  const toggleToolTip = () => {
    setTooltipOpen(!tooltipOpen);
  }

  const sendNotification = (data, selectedUser) => {
    console.log(selectedUser);
    // if (selectedUser === "Patient") {
    //   setApiCallParams({
    //     reqType: "POST",
    //     // reqUrl: sendNotificationsPatientApiRoute,
    //     reqUrl: sendNotificationsApiRoute,
    //     dataObj: data,
    //     successCallback: res => {
    //       setShowNotificationModal(false);
    //       setModalText("Notification Sent Successfully");
    //       setShowTextModal(true);
    //     },
    //     failureCallback: err => {
    //       setShowNotificationModal(false);
    //       setModalText(
    //         "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
    //       );
    //       setShowTextModal(true);
    //     }
    //   });
    // }
    // else {
    setApiCallParams({
      reqType: "POST",
      reqUrl: sendNotificationsApiRoute,
      dataObj: data,
      successCallback: res => {
        setShowNotificationModal(false);
        setModalText("Notification Sent Successfully");
        setShowTextModal(true);
      },
      failureCallback: err => {
        setShowNotificationModal(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
    // }
  };

  //Temp for IV&V test
  /* 
  const downloadSOAPLog = val => {
    let date = new Date().toLocaleDateString("en-CA");
    if (!val) {
      date = new Date(new Date().getTime() - 86400000).toLocaleDateString(
        "en-CA"
      );
    }

    setApiCallParams({
      reqType: "GET",
      reqUrl: tempSOAPLog,
      params: { date },
      successCallback: res => {
        console.log(res);
        if (res.data && res.data.data) {
          const data = res.data.data;
          if (data === "Log file does not exist") {
            setModalText("There is no SOAP log file");
            setShowTextModal(true);
          } else {
          // create and download a file containing the data from backend
            const blobObj = new Blob([data], {
              type: "text/txt,charset=UTF-8"
            });
            let blobUrl = window.URL.createObjectURL(blobObj);
            const filename = "SOAP log_" + date + ".log";
            const aElement = document.createElement("a");
            document.body.appendChild(aElement);
            aElement.style.display = "none";
            aElement.href = blobUrl;
            aElement.download = filename;
            aElement.click();
            document.body.removeChild(aElement);
          }
        } else {
          setModalText("There is no SOAP log file");
          setShowTextModal(true);
        }
        setShowNotificationModal(false);
      },
      failureCallback: err => {
        console.error("downloadSOAPLog err 2", err);
        setShowNotificationModal(false);
        setModalText(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        );
        setShowTextModal(true);
      }
    });
  };
 */

  return (
    <div
      className="top-nav-container container-fluid d-flex flex-row justify-content-between pl-5 pr-5 pt-3 pb-3 fixed-top">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
      <CustomModal
        openModal={showNotificationModal}
        cancelEvent={toggleNotificationModal}
        title="Send Notification"
        modalBodyContent={
          <SendNotificationForm onFormSubmit={sendNotification} />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showLogoutModal}
        cancelEvent={toggleLogoutModal}
        okayEvent={logOut}
        modalBodyContent={
          <p className="text-center mb-0">Are you sure you want to logout ?</p>
        }
      />
      <div className="top-nav-left d-flex flex-row justify-content-between">
        <img src={ICLogo} alt="ic-logo" className="ic-logo" />
        <div className="tp-nav-searchbox-container">
          <SearchPR />
        </div>
      </div>

      {/* Temp for IV&V test */}
      {/* <Button
        className="top-nav-right"
        clickEvent={() => downloadSOAPLog(0)}
        title="SOAP before 10am"
      ></Button>
      <Button
        className="top-nav-right"
        clickEvent={() => downloadSOAPLog(1)}
        title="SOAP after 10am"
      ></Button> */}
      {/*<span className="flex-grow-1"></span>*/}
      <div className="row">
        <div id="connectedDoctors" className="m-2 queue-count-badge badge"><i
          className="m-2 fas fa-user-md"></i><span>{props.queueCount.doctorsOnline && props.queueCount.doctorsOnline.icDoctorCount > 0 ? props.queueCount.doctorsOnline.icDoctorCount : '-'}</span></div>
        <Tooltip id="doctors-connected-top-nav-tooltip" placement="left" className="doctors-connected-topnav-tooltip" isOpen={tooltipOpen} target="connectedDoctors" toggle={toggleToolTip}>
          <ul>
            {
              props.queueCount.doctorsOnline && props.queueCount.doctorsOnline.connectedDoctors && props.queueCount.doctorsOnline.connectedDoctors.map((doctor, index) => {
                return <li key={index}>{`${doctor.doctorId} | ${doctor.doctorName} ${doctor.isMac ? '- MAC' : '- Windows'}`}</li>
              })
            }

            {
              props.queueCount.doctorsOnline && props.queueCount.doctorsOnline.connectedDoctors && props.queueCount.doctorsOnline.connectedDoctors.length === 0 && (
                <li>N/A</li>
              )
            }
          </ul>
        </Tooltip>
        <div className="m-2 queue-count-badge badge"><i className="m-2 fa fa-users"></i>
          <span>{props.queueCount.patientsInQueue}</span></div>
      </div>

      <div className="top-nav-right">
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle nav caret>
            <img
              className="rounded-circle user-pic"
              src={
                user !== null &&
                user.profilePic !== null &&
                user.profilePic !== undefined
                  ? user.profilePic.original
                  : ICNoImg
              }
              alt="user-pic"
            />{" "}
            {user ? user.firstName : ""} {user ? user.lastName : ""}
          </DropdownToggle>

          <DropdownMenu right>
            <DropdownItem className="top-nav-list-item">
              <Link to={appRoutes.changePassword}>
                <i className="fa fa-lock"></i>&nbsp;&nbsp;&nbsp;Change Password
              </Link>
            </DropdownItem>
            <DropdownItem className="top-nav-list-item">
              <Link to={appRoutes.changePin}>
                <i className="fas fa-fingerprint"></i>
                &nbsp;&nbsp;&nbsp;Change Pin
              </Link>
            </DropdownItem>
            <DropdownItem
              onClick={toggleNotificationModal}
              className="top-nav-list-item"
            >
              <i className="far fa-bell"></i>&nbsp;&nbsp;&nbsp;Send Notification
            </DropdownItem>
            <DropdownItem
              className="top-nav-list-item"
              onClick={toggleLogoutModal}
            >
              <i className="fas fa-sign-out-alt"></i>
              &nbsp;&nbsp;&nbsp;Logout
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  queueCount: state.queueCount
});

const mapDispatchToProps = dispatch => ({
  logOutUser: () => dispatch(logOutUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavBar);
